import React, { useCallback } from "react";

import Form from "antd/es/form";
import Radio from "antd/es/radio";
import Space from "antd/es/space";
import { IntlShape } from "react-intl";

import CheckInVisibility from "@mapmycustomers/shared/enum/CheckInVisibility";

import RadioGroup from "@app/component/input/RadioGroup";
import TextWithInfo from "@app/component/typography/TextWithInfo";
import useAnalytics from "@app/util/contexts/useAnalytics";
import { getCheckInVisibilityDisplayName } from "@app/util/ui";

import styles from "./FormItems.module.scss";

interface Props {
  intl: IntlShape;
}

const CheckItVerifiedVisibility: React.FC<Props> = ({ intl }) => {
  const analyticIssuer = useAnalytics();
  const handleCheckInVisibilityChange = useCallback(
    (value: CheckInVisibility) => {
      let visibility: string;
      if (value === CheckInVisibility.SHARED_WITH_MANAGERS) {
        visibility = "Managers";
      } else if (value === CheckInVisibility.SHARED_WITH_ORGANIZATION) {
        visibility = "Everyone";
      } else {
        visibility = "Only Owner";
      }
      analyticIssuer?.clicked([`Show Check-Ins ${visibility}`]);
    },
    [analyticIssuer]
  );
  return (
    <div className={styles.formItemContainer}>
      <TextWithInfo
        className={styles.fieldTitle}
        info={intl.formatMessage({
          id: "settings.organizationDetails.checkInVerifiedVisibility.infoText",
          defaultMessage:
            "Check-in verification status will appear on activities and reports throughout the application. Control which users can see such information here.",
          description:
            "Activity check in verified visibility info text of settings organization details",
        })}
      >
        {intl.formatMessage({
          id: "settings.organizationDetails.checkInVerifiedVisibility.label",
          defaultMessage: "Show check-ins as verified / un-verified to:",
          description:
            "Activity check in verified visibility label of settings organization details",
        })}
      </TextWithInfo>
      <Form.Item name="checkInVerifiedVisibility">
        <RadioGroup<CheckInVisibility> onChange={handleCheckInVisibilityChange}>
          <Space className={styles.space} direction="vertical">
            <Radio className={styles.radio} value={CheckInVisibility.PRIVATE}>
              {getCheckInVisibilityDisplayName(intl, CheckInVisibility.PRIVATE)}
            </Radio>
            <Radio className={styles.radio} value={CheckInVisibility.SHARED_WITH_MANAGERS}>
              {getCheckInVisibilityDisplayName(intl, CheckInVisibility.SHARED_WITH_MANAGERS)}
            </Radio>
            <Radio className={styles.radio} value={CheckInVisibility.SHARED_WITH_ORGANIZATION}>
              {getCheckInVisibilityDisplayName(intl, CheckInVisibility.SHARED_WITH_ORGANIZATION)}
            </Radio>
          </Space>
        </RadioGroup>
      </Form.Item>
    </div>
  );
};

export default CheckItVerifiedVisibility;
